<template>
  <VueDrawingCanvas
    ref="vueCanvasDrawingRef"
    v-show="isShow.canvas"
    :width="canvasOptions.width"
    :height="canvasOptions.height"
    :stroke-type="canvasOptions.strokeType"
    :line-cap="canvasOptions.lineCap"
    :line-join="canvasOptions.lineJoin"
    :fill-shape="canvasOptions.fillShape"
    :eraser="canvasOptions.eraser"
    :lineWidth="canvasOptions.lineWidth"
    :color="canvasOptions.color"
    :background-color="canvasOptions.backgroundColor"
    :background-image="canvasOptions.backgroundImage"
    :watermark="canvasOptions.watermark"
    :initial-image="canvasOptions.initialImage"
    :saveAs="canvasOptions.saveAs"
    :styles="canvasOptions.styles"
    :lock="canvasOptions.lock"
    :additional-images="canvasOptions.additionalImages"
  />
  <img
    v-if="!isShow.canvas"
    :src="rentalContractEditForm.signaturePath"
    class="img-fluid"
    style="border: solid 1px #000"
  />
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import VueDrawingCanvas from "vue-drawing-canvas";

/* Import TypeScript */
import {
  vueCanvasDrawingRef,
  isShow,
  rentalContractEditForm,
} from "../../compositions/variables";
import { canvasOptions, getWidthSize, resizeWidth } from "../../compositions/script/canvas";

export default defineComponent({
  components: {
    VueDrawingCanvas,
  },
  setup() {
    vueCanvasDrawingRef.value = ref<any>(null);
    onMounted(() => {
      getWidthSize();
    });

    onMounted(() => {
      window.addEventListener('resize', resizeWidth)
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeWidth)
    })

    return {
      /* functions */

      /* variables */
      canvasOptions,
      vueCanvasDrawingRef,
      isShow,
      rentalContractEditForm,
    };
  },
});
</script>
